import gql from 'graphql-tag';

export const organizationOverviewQuery = gql`
  query getOrganizations {
    allContent(where: { OR: [{ contentTypeAlias: "partner" }, { contentTypeAlias: "charity" }, { contentTypeAlias: "supplier" }] }) {
      items {
        ... on Partner {
          title
          logo {
            cropUrl(alias: "Partner Logo")
          }
          url
        }
        ... on Charity {
          title
          logo {
            cropUrl(alias: "Partner Logo")
          }
          url
        }
        ... on Supplier {
          title
          logo {
            cropUrl(alias: "Partner Logo")
          }
          url
        }
      }
    }
  }
`;
